import {getDaysAgo} from '@sollapay/utils';

import type {TeamFilterState} from '../config/team-filter.config';
import type {FirmMemberDTO} from '@sollapay/types';

export function matchesMemberSearch(
  member: {email: string; name?: string | null},
  searchText: string
): boolean {
  const query = searchText.trim().toLowerCase();
  if (!query) return true;
  return (
    member.email.toLowerCase().includes(query) ||
    (member.name?.toLowerCase().includes(query) ?? false)
  );
}

export function isTeamFilterActive(filter: TeamFilterState): boolean {
  return filter.statuses.length > 0 || filter.roleKeys.length > 0 || filter.createdAt !== 'all';
}

export function countTeamActiveFilters(filter: TeamFilterState): number {
  let count = filter.statuses.length + filter.roleKeys.length;
  if (filter.createdAt !== 'all') count++;
  return count;
}

const CREATED_AT_MAX_DAYS: Record<Exclude<TeamFilterState['createdAt'], 'all'>, number> = {
  this_week: 7,
  '7d': 7,
  '30d': 30,
  '90d': 90
};

export function applyTeamFilter(
  members: FirmMemberDTO[],
  filter: TeamFilterState
): FirmMemberDTO[] {
  return members.filter(member => {
    if (filter.statuses.length > 0 && !filter.statuses.includes(member.status)) return false;
    if (filter.roleKeys.length > 0 && !filter.roleKeys.includes(member.roleKey)) return false;
    if (filter.createdAt !== 'all') {
      const maxDays = CREATED_AT_MAX_DAYS[filter.createdAt];
      if (getDaysAgo(new Date(member.createdAt)) > maxDays) return false;
    }
    return true;
  });
}
